export const CREATE_PAYROLL_LOAN = "CREATE_PAYROLL_LOAN";
export const FETCH_PAYROLL_LOANS = "FETCH_PAYROLL_LOANS";
export const EDIT_PAYROLL_LOAN = "EDIT_PAYROLL_LOAN";
export const DELETE_PAYROLL_LOAN = "DELETE_PAYROLL_LOAN";
